import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from "prop-types";
import bg from "../../assets/images/HeaderDocument.jpg";
import "./base.css";

const HRM_013 = ({ pdfExportComponent, data, company2 }) => {
  return (
    <>
      <div id="document-box" className="documents">
        <PDFExport
          ref={pdfExportComponent}
          fileName={`แบบฟอร์มประกาศเรื่องการดำเนินการกับพนักงานที่ทุจริต - ${data.personal_info_name}`}
          forcePageBreak=".page-break"
        >
          <div id="page1" style={{ fontFamily: "THSarabun" }}>
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "absolute",
                  top: "0%",
                  right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
            <div
              id="content"
              style={{
                zIndex: 2,
              }}
            >
              <div
                id="formId"
                className="text-with-bold"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "125px",
                  right: "65px",
                  border: "1px",
                  borderStyle: "solid",
                  padding: "8px",
                  paddingBottom: "0px",
                  paddingTop: "5px",
                  width: "70px",
                  fontSize: "16px",
                  letterSpacing: 0.14,
                }}
              >
                <b className="docs-font-bold">HRM-013</b>
              </div>
              <div
                id="date"
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "190px",
                  right: "76px",
                  fontSize: "18.2px",
                  // fontFamily: "angsaLight",
                  width: "647px",
                  letterSpacing: 0.14,
                  textAlign: "right",
                }}
              >
                วันที่...........เดือน....................................พ.ศ.................
              </div>
              <div
                id="paragraph1"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "215px",
                  right: "74px",
                  fontSize: "18px",
                  // fontFamily: "angsaLight",
                  width: "655px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "27px",
                }}
              >
                <p />
                &nbsp;&emsp;&emsp;&emsp;ด้วยข้าพเจ้านาย/นาง/นางสาว........................................................................................................อายุ.......................ปี
                ตำแหน่งงาน  ..............................................................................................................................................................................................
                แผนก/ฝ่าย
                .......................................................................................................................
                ปฏิบัติงานวันที่
                ...............................................
                ได้รับทราบถึง&nbsp;
                <u>
                  <b className="docs-font-bold">
                    “ประกาศเรื่องการดำเนินการกับพนักงานที่ทุจริต”
                  </b>
                </u>
                &nbsp; ฉบับลงวันที่ 1 กันยายน 2553
                และพร้อมที่จะปฏิบัติหน้าที่ด้วยความซื่อสัตย์สุจริต
                <br />
                <p />
                &nbsp;&emsp;&emsp;&emsp;หากข้าพเจ้าได้ปฏิบัติงานในอันเป็นการทุจริต
                หรือกระทำอื่นใดอันเป็นเหตุให้เข้าการกระทำที่ถือว่าเป็นการทุจริตต่อบริษัทฯ
                หรือทำให้บริษัทฯ ได้รับความเสียหาย ข้อหนึ่งข้อใดของประกาศฯ
                ฉบับนี้ข้าพเจ้ายินดีให้บริษัทฯ
                ดำเนินคดีอาญาเพื่อให้เกิดโทษจำคุกจนถึงที่สุด
                และให้ดำเนินคดีแพ่งต่อศาลแรงงานกลางเพื่อยึดอายัดทรัพย์ของข้าพเจ้าจนกว่าบริษัทฯ
                จะได้รับชำระหนี้ค่าเสียหายจนครบถ้วน
                <br />
                <br />
                <br />
                <br />
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................พนักงาน
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(........................................................................)
              </div>
            </div>
            <div id="var" className="var">
              {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                id="date_day"
                className="date day docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "188.5px",
                  right: "286px",
                  fontSize: "18.2px",
                  width: "30px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_day}
              </div>

              <div
                id="date_month"
                className="date month docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "188.5px",
                  right: "150px",
                  fontSize: "18.2px",
                  width: "106px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_month}
              </div>

              <div
                id="date_year"
                className="date year docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "188.5px",
                  right: "79px",
                  fontSize: "18.2px",
                  width: "46px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_year}
              </div>

              <div
                id="personal_info_name"
                className="personal_info name docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "213px",
                  right: "174px",
                  fontSize: "18.2px",
                  width: "313px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
              <div
                id="personal_info_age"
                className="personal_info age docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "215px",
                  right: "85px",
                  fontSize: "18.2px",
                  width: "64px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_age}
              </div>
              <div
                id="personal_info_age"
                className="personal_info age docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "240.5px",
                  right: data.detail_position?.length >= 40 ? "227px" : ( data.detail_position?.length <= 16 ? "400px" : "330px"),
                  fontSize: "18.2px",
                  width: "300px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.detail_position} 
              </div>

              <div
                id="personal_info_age"
                className="personal_info age docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "267.5px",
                  right: data.detail_department?.lengt >= 40 ? "359px" : ( data.detail_department?.length <= 16 ? "380px" : "384px"),
                  fontSize: "18.2px",
                  width: "235px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data?.detail_department?.split("_")[1] ||
                  data?.detail_department?.split("_")[0]} 
              </div>

              <div
                id="personal_info_age"
                className="personal_info age docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "267px",
                  right: "34px",
                  fontSize: "18.2px",
                  width: "229px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.detail_start_date}
              </div>
              <div
                id="personal_info_age"
                className="personal_info age docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "563px",
                  right: "212px",
                  fontSize: "18.2px",
                  width: "215px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
            </div>
          </div>
        </PDFExport>
      </div>
    </>
  );
};

HRM_013.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
};

export default HRM_013;
